// eslint-disable-next-line prettier/prettier
import type { NavigationItem } from '~/types/sanity/navigation';

import type { ConsignmentStatus } from '@montugroup/contracts-warehousing-api';
import { DEFAULT_COUNTRY_CODE } from './misc';

export enum AccountLinkId {
  MY_ACCOUNT = 'my_account',
  PERSONAL_DETAILS = 'personal_details',
  LOYALTY = 'loyalty',
  ORDERS = 'orders',
  SHIPMENTS = 'shipments',
  RETURNS = 'returns',
}

export type OrderStatus = Extract<ConsignmentStatus, 'RECEIVED' | 'AWAITING_SHIPMENT' | 'IN_TRANSIT' | 'CANCELLED'>;

export const states: Record<string, { code: string; name: string }[]> = {
  AU: [
    { code: 'ACT', name: 'Australian Capital Territory' },
    { code: 'NSW', name: 'New South Wales' },
    { code: 'NT', name: 'Northern Territory' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'SA', name: 'South Australia' },
    { code: 'TAS', name: 'Tasmania' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'WA', name: 'Western Australia' },
  ],
};

export const stateOptions = states[DEFAULT_COUNTRY_CODE].map((state) => ({
  label: state.name,
  value: state.code,
}));

export const fulfillmentStatusLabels: Record<OrderStatus, string> = {
  RECEIVED: 'Delivered',
  AWAITING_SHIPMENT: 'Awaiting Shipment',
  IN_TRANSIT: 'In Transit',
  CANCELLED: 'Cancelled',
};

export const defaultLineItemLimit = 100;

export const UNSIGNED_SHIPMENT_THRESHOLD_TO_ALERT = 0;

export const accountMenuItem: NavigationItem = {
  _key: 'account_menu_item',
  linkType: 'internal',
  icon: undefined,
  label: 'Account',
  authVisibility: 'loggedIn',
  featureFlag: null,
  urlType: 'page',
  url: '/pages/account',
  submenu: null,
  id: 'header_account_nav',
};
